import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, setApiKeyToObject } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const SiteJobDescriptionPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 공고 단일 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionDetailForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionDetailForPublic: ({ customerIdHash, jobDescriptionIdHash }, options = {}) => {
      assertParamExists("getSiteJobDescriptionDetailForPublic", "customerIdHash", customerIdHash);
      assertParamExists("getSiteJobDescriptionDetailForPublic", "jobDescriptionIdHash", jobDescriptionIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/job-descriptions/{jobDescriptionIdHash}/details`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash))).replace(`{${"jobDescriptionIdHash"}}`, encodeURIComponent(String(jobDescriptionIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getSiteJobDescriptionDetailForPublic",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary 정렬된 공고 리스트 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionsForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionsForPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getSiteJobDescriptionsForPublic", "customerIdHash", customerIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/sites/job-descriptions`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getSiteJobDescriptionsForPublic",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const SiteJobDescriptionPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = SiteJobDescriptionPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 공고 단일 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionDetailForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionDetailForPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getSiteJobDescriptionDetailForPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 정렬된 공고 리스트 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionsForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionsForPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getSiteJobDescriptionsForPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const SiteJobDescriptionPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = SiteJobDescriptionPublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @summary 공고 단일 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionDetailForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionDetailForPublic(requestParameters, options) {
      return localVarFp.getSiteJobDescriptionDetailForPublic(requestParameters, options)(axios, basePath);
    },
    /**
     * 
     * @summary 정렬된 공고 리스트 조회 API
     * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionsForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSiteJobDescriptionsForPublic(requestParameters, options) {
      return localVarFp.getSiteJobDescriptionsForPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class SiteJobDescriptionPublicControllerApi extends BaseAPI {
  /**
   * 
   * @summary 공고 단일 조회 API
   * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionDetailForPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteJobDescriptionPublicControllerApi
   */
  getSiteJobDescriptionDetailForPublic(requestParameters, options) {
    return SiteJobDescriptionPublicControllerApiFp(this.configuration).getSiteJobDescriptionDetailForPublic(requestParameters, options)(this.axios, this.basePath);
  }
  /**
   * 
   * @summary 정렬된 공고 리스트 조회 API
   * @param {SiteJobDescriptionPublicControllerApiGetSiteJobDescriptionsForPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteJobDescriptionPublicControllerApi
   */
  getSiteJobDescriptionsForPublic(requestParameters, options) {
    return SiteJobDescriptionPublicControllerApiFp(this.configuration).getSiteJobDescriptionsForPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getSiteJobDescriptionDetailForPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: SiteJobDescriptionPublicControllerApiAxiosParamCreator().getSiteJobDescriptionDetailForPublic,
  requestFn: SiteJobDescriptionPublicControllerApiFp().getSiteJobDescriptionDetailForPublic
});
const getSiteJobDescriptionsForPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: SiteJobDescriptionPublicControllerApiAxiosParamCreator().getSiteJobDescriptionsForPublic,
  requestFn: SiteJobDescriptionPublicControllerApiFp().getSiteJobDescriptionsForPublic
});

export { SiteJobDescriptionPublicControllerApi, SiteJobDescriptionPublicControllerApiAxiosParamCreator, SiteJobDescriptionPublicControllerApiFactory, SiteJobDescriptionPublicControllerApiFp, getSiteJobDescriptionDetailForPublicRemote, getSiteJobDescriptionsForPublicRemote };
//# sourceMappingURL=site-job-description-public-controller-api.mjs.map
